import _extends from "@babel/runtime/helpers/extends";
import { ChevronDown, ChevronUp } from "lucide-react";
import React from "react";
import { BaseDropdownIndicator } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function CustomDropdownIndicator(innerProps) {
  var _innerProps$selectPro = innerProps.selectProps,
    menuIsOpen = _innerProps$selectPro.menuIsOpen,
    isDisabled = _innerProps$selectPro.isDisabled;
  return /*#__PURE__*/_jsx(BaseDropdownIndicator, _extends({}, innerProps, {
    disabled: isDisabled,
    children: menuIsOpen ? /*#__PURE__*/_jsx(ChevronUp, {
      size: "1rem",
      color: "currentColor"
    }) : /*#__PURE__*/_jsx(ChevronDown, {
      size: "1rem",
      color: "currentColor"
    })
  }));
}
export default CustomDropdownIndicator;